import FiltersI from '../interfaces/Filters';

const Filters = ({ filters, setFilters }: FiltersI) => {
    return (
        <>
            <span className="form-span">Search:</span>
            <input
                className="form-input"
                type="text"
                placeholder="Name, stage name, guestID, email, phone, license"
                value={filters.query}
                onChange={(e) =>
                    setFilters((prev) => ({ ...prev, query: e.target.value }))
                }
            />

            <span className="form-span">Age range:</span>
            <input
                className="form-input"
                type="number"
                placeholder="Min"
                value={filters.ageMin}
                onChange={(e) =>
                    setFilters((prev) => ({ ...prev, ageMin: e.target.value }))
                }
            />
            <input
                className="form-input margin"
                type="number"
                placeholder="Max"
                value={filters.ageMax}
                onChange={(e) =>
                    setFilters((prev) => ({ ...prev, ageMax: e.target.value }))
                }
            />

            <span className="form-span">Recent entry date range:</span>
            <input
                className="form-input"
                type="date"
                value={filters.dateFrom}
                onChange={(e) =>
                    setFilters((prev) => ({
                        ...prev,
                        dateFrom: e.target.value,
                    }))
                }
            />
            <input
                className="form-input margin"
                type="date"
                value={filters.dateTo}
                onChange={(e) =>
                    setFilters((prev) => ({ ...prev, dateTo: e.target.value }))
                }
            />

            <span className="form-span">Standing:</span>
            <select
                className="select-input"
                value={filters.standing}
                onChange={(e) =>
                    setFilters((prev) => ({
                        ...prev,
                        standing: e.target.value as '' | 'GOOD' | 'BAD',
                    }))
                }
            >
                <option value="">Any</option>
                <option value="GOOD">Good</option>
                <option value="BAD">Bad</option>
            </select>

            <span className="form-span">TOS accepted:</span>
            <select
                className="select-input"
                value={filters.tos}
                onChange={(e) =>
                    setFilters((prev) => ({
                        ...prev,
                        tos: e.target.value as '' | 'yes' | 'no',
                    }))
                }
            >
                <option value="">Any</option>
                <option value="yes">Accepted</option>
                <option value="no">Not accepted</option>
            </select>
        </>
    );
};

export default Filters;
